import { Check } from "lucide-react";

const reasons = [
  "Évtizedes szakértelemmel dolgozunk, amit kevés vállalkozás mondhat el.",
  "A vályogépítészet mesterei vagyunk, nem csak értünk hozzá!",
  "Minden projektet prémium minőségben, szigorú precizitással vállalunk.",
  "Ügyfeleinkkel valódi partnerséget alakítunk ki.",
  "A természetes, egészséges és fenntartható otthonok terén mi diktálunk.",
];

const stats = [
  { value: "20+", label: "Év tapasztalat" },
  { value: "145+", label: "Befejezett projekt" },
  { value: "98%", label: "Elégedett ügyfél" },
];

const WhyUsSection = () => {
  const scrollToSurvey = () => {
    const element = document.querySelector("#survey");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="py-20 md:py-32 bg-blue-900 text-white relative overflow-hidden"
    >
      {/* Geometric Background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-800 rounded-full blur-3xl opacity-50" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-blue-700 rounded-full blur-2xl opacity-30" />
      
      <div className="container mx-auto px-6 md:px-12 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-white/10 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              MIÉRT VAGYUNK JOBBAK?
            </div>
            
            <h2
              className="text-3xl md:text-5xl font-extrabold tracking-tight mb-6"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Emberiség a profizmus mellett
            </h2>
            
            <p className="text-lg text-blue-100 leading-relaxed mb-8">
              Nálunk az ügyfél nem csupán megrendelő — partner. A teljes folyamat során kommunikálunk, egyeztetünk, és addig finomítjuk a terveket, amíg a valóság tökéletesen vissza nem tükrözi a tulajdonos elképzeléseit.
            </p>

            <ul className="space-y-4 mb-10">
              {reasons.map((reason, index) => (
                <li
                  key={index}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-blue-50">{reason}</span>
                </li>
              ))}
            </ul>

            <button
              data-testid="why-us-cta-btn"
              onClick={scrollToSurvey}
              className="bg-white text-blue-900 px-8 py-4 text-lg font-bold rounded-full hover:bg-blue-50 transition-all shadow-lg hover:scale-105 active:scale-95"
            >
              Foglalj felmérést még ma
            </button>
          </div>

          {/* Right: Stats */}
          <div className="grid grid-cols-1 gap-6">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/10"
              >
                <div
                  className="text-5xl md:text-6xl font-extrabold text-white mb-2"
                  style={{ fontFamily: "'Manrope', sans-serif" }}
                >
                  {stat.value}
                </div>
                <div className="text-blue-200 font-medium text-lg">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
